import { Typography } from "antd";
import React from "react";

function Commonformlabel({
  required,
  labelname,
  style,
}: {
  required: boolean;
  labelname: string | undefined;
  style?: any;
}) {
  return (
    <>
      <Typography style={style}>
        {labelname}&nbsp;
        {required && <span className="required_text">*</span>}
      </Typography>
    </>
  );
}

export default Commonformlabel;
